<div class="dummy-wrapper">
	<div class="ds-flex-start-center">
		<img [src]="'./assets/Teacher (Blue-Gray).svg'" alt="" />
	</div>
	<div class="dummy">
		<!--    <div style="font-size: 17px;"> No Access</div>-->
		<div style="font-size: 17px; width: 500px">Account does not have any associated teachers. Please contact your school admin.</div>
	</div>
</div>
